import axios from 'axios';
import { isBrowser } from '../utils/detectEnv';
import { errorEvents } from '../utils/analytics';
import { AUTH_FORM_PATH, HOME_PAGE_PATH_ARRAY } from '../utils/constants';

/* this is in place as at this time when we get an error from the
akamai system THD will send some sort page like the "Oops we are fixing it"
page. We decided that instead we'd just render the appropriate error message
set up for whatever request is being made */
function handleAkamaiErrorResponse(res) {
  errorEvents.postPageError('Akamai Error', `${res?.status}: ${res?.statusText}`);
  return Promise.reject(new Error('Oops something went wrong.'));
}

const slmAxiosClient = axios.create({
  baseURL: '/slam',
  withCredentials: true
});

slmAxiosClient.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    'Cache-Control': 'max-age=0, no-cache, no-store',
    ...(window?.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId() && {
      tmxProfileId: window.THD_ACCOUNT_LIB.TMX.getTMXsessionId()
    })
  };
  return config;
});

slmAxiosClient.interceptors.response.use(
  function handleSuccessfulResponse(res) {
    /* Traffic manager through akamai will intercept some responses
       and send back a 200 response, even though there is an error
       The most consistent field in these responses is the
       html it sends back which is the "oops we are fixing it"
       page you see from time to time. See comment on function
       for implementation details
    */
    if (isBrowser() && res.headers['content-type'] === 'text/html') {
      return handleAkamaiErrorResponse(res);
    }
    return res;
  },
  function handleRejectedResponse(error) {
    if (isBrowser()) {
      if (error.response.status === 401 && window.location.pathname !== AUTH_FORM_PATH) {
        errorEvents.postPageError(error.response?.data?.message, 401);
        window.location.replace(`${AUTH_FORM_PATH}?redirect=${window.location.pathname}`);
      }

      if (error.response?.status === 403 && !(HOME_PAGE_PATH_ARRAY.includes(window.location.pathname))) {
        window.location.replace(`${AUTH_FORM_PATH}?redirect=${window.location.pathname}`);
      }
    }
    return Promise.reject(error);
  }
);

export default slmAxiosClient;
